import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_spinner_facebook = _resolveComponent("q-spinner-facebook")!
  const _component_q_inner_loading = _resolveComponent("q-inner-loading")!
  const _component_q_page = _resolveComponent("q-page")!
  const _component_q_page_container = _resolveComponent("q-page-container")!

  return (_openBlock(), _createBlock(_component_q_page_container, {
    class: _normalizeClass(["main__container", { 'main__container__is-loading': _ctx.isLoading }])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_page, { "style-fn": _ctx.ssrHeight }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view, null, {
            default: _withCtx(({ Component }) => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ]),
            _: 1
          }),
          _createVNode(_component_q_inner_loading, {
            class: "preloader",
            showing: _ctx.showLoading
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_spinner_facebook, {
                color: "brand",
                size: "56px"
              })
            ]),
            _: 1
          }, 8, ["showing"])
        ]),
        _: 1
      }, 8, ["style-fn"])
    ]),
    _: 1
  }, 8, ["class"]))
}